import { render, staticRenderFns } from "./prePage.vue?vue&type=template&id=6dc68b88&scoped=true&"
import script from "./prePage.vue?vue&type=script&lang=js&"
export * from "./prePage.vue?vue&type=script&lang=js&"
import style0 from "./prePage.vue?vue&type=style&index=0&id=6dc68b88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc68b88",
  null
  
)

export default component.exports